import { clientOnlyLazy } from 'components/ClientOnlySuspense/clientOnlyLazy';
import { LoadableLoadingSection } from 'components/LoadableLoadingSection';

export const UserDashboardPostAListingPageContainerLoadable = clientOnlyLazy({
  loader: () =>
    import(
      /* webpackChunkName: "UserDashboardPostAListingPageContainer" */
      './UserDashboardPostAListingPageContainer.dynamic'
    ),
  loading: LoadableLoadingSection,
});
